class UGCModal extends HTMLElement {
  constructor() {
    super();

    this.close = this.querySelectorAll(".ugc-gallery-modal__close");
    this.main_slider = this.querySelector(".ugc-gallery-slider");
    this.product_section = this.querySelector(".ugc-gallery-modal__product");
    this.product_to_show = null;
    this.sectionId = this.closest(".shopify-section").id;
    this.open_on_load = false;
    this.headerLink = document.querySelector(".site-header__logo-link");

    this.main_slider.addEventListener("moved", (e) => {
      this.mainSlideChange();
      const bounceAnimated = this.querySelector(
        ".ugc-gallery-slider__slide.bounce"
      );
      if (bounceAnimated) {
        bounceAnimated.classList.remove("bounce");
        this.querySelector(".ugc-gallery").classList.remove("has-overlay");
      }
    });

    if (this.close.length) {
      this.close.forEach((el) => {
        el.addEventListener("click", (e) => {
          this.closeGallery();
        });
      });
    }

    if (
      sessionStorage.getItem("ugc_gallery") &&
      sessionStorage.getItem("ugc_gallery") == this.sectionId
    ) {
      this.open_on_load = true;
      this.openGallery();
    }
  }

  mainSlideChange() {
    const mainSlide = this.querySelector(
      ".ugc-gallery-slider__slide.is-active"
    );
    //if a product slider is present in the main slide
    if (!mainSlide) return;
    const productSlider = mainSlide.querySelector(".ugc-products-slider");
    if (productSlider) {
      const activeProduct = productSlider.querySelector(
        ".splide__slide.is-active"
      );
      const activeProductId = activeProduct.getAttribute("data-product-handle");
      if (activeProductId != this.product_to_show) {
        this.productSlideChange(activeProductId);
      }
    } else if (this.product_section.getAttribute("data-default-product")) {
      //if no product slider is present, use the default product
      const defaultProduct = this.product_section.getAttribute(
        "data-default-product"
      );
      if (defaultProduct != this.product_to_show) {
        this.productSlideChange(defaultProduct);
      }
    } else {
      const defaultProduct = '';
       if (defaultProduct != this.product_to_show) {
        this.productSlideChange(defaultProduct);
      }
    }

    //bounce animation
    if (
      !mainSlide.classList.contains("last-slide") &&
      !this.classList.contains("scrolled")
    ) {
      mainSlide.classList.add("bounce");
      setTimeout(() => {
        mainSlide.classList.remove("bounce");
      }, 6000);
    } else {
      this.classList.add("scrolled");
    }

    sessionStorage.setItem(
      "ugc_gallery_slide",
      mainSlide.getAttribute("data-slide-index")
    );
    sessionStorage.setItem("ugc_gallery_prod", "0");
  }

  productSlideChange(newProduct) {
    this.product_to_show = newProduct;

    if (this.product_to_show != '') {
       fetch(`/products/${this.product_to_show}?section_id=ugc-product`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const nestedElement = html.querySelector(".product-main__purchase");
        this.product_section.innerHTML = nestedElement.innerHTML;
      });

      document.querySelectorAll(".product-card-wrapper").forEach((el) => {
        el.classList.remove("product-card-wrapper--expanded");
      });

    } else {
      this.product_section.innerHTML = '';
    }

   
  }

  openGallery() {
    this.initProductSliders();

    this.classList.add("active");
    document.querySelector("body").classList.add("ugc-gallery-active");

    this.mainSlideChange();
    draggableCursor();

    if (!this.open_on_load) {
      sessionStorage.setItem("ugc_gallery", this.sectionId);
      sessionStorage.setItem("ugc_gallery_slide", "0");
      sessionStorage.setItem("ugc_gallery_prod", "0");
    }

    if (this.headerLink) {
      this.headerLink.addEventListener("click", (e) => {
        if (this.classList.contains("active")) {
          sessionStorage.removeItem("ugc_gallery");
          sessionStorage.removeItem("ugc_gallery_slide");
          sessionStorage.removeItem("ugc_gallery_prod");
        }
      });
    }
  }

  closeGallery() {
    this.classList.remove("active");
    document.querySelector("body").classList.remove("ugc-gallery-active");
    sessionStorage.removeItem("ugc_gallery");
    sessionStorage.removeItem("ugc_gallery_slide");
    sessionStorage.removeItem("ugc_gallery_prod");
  }

  initProductSliders() {
    const mainSlides = this.main_slider.querySelectorAll(".splide__slide");

    mainSlides.forEach((slide) => {
      const productSlider = slide.querySelector(".ugc-products-slider");
      if (productSlider) {
        const prodsSplide = new Splide(productSlider, {
          fixedWidth: "316px",
          perPage: 2,
          perMove: 1,
          updateOnMove: true,
          snap: true,
          drag: true,
          trimSpace: false,
          pagination: false,
          arrows: false,
          flickPower: 100,
          flickMaxPages: 1,
          focus: 0,
          gap: "var(--space-4)",
          padding: {
            right: "calc(var(--padding-sections-desktop) * 2)",
          },
          breakpoints: {
            1399: {
              perPage: 1,
            },
            749: {
              perPage: 2,
            },
            599: {
              perPage: 1,
            },
          },
        }).mount();

        prodsSplide.on("active", () => {
          this.mainSlideChange();
        });

        prodsSplide.on("moved", (slide) => {
          sessionStorage.setItem("ugc_gallery_prod", slide);
        });

        productSlider.addEventListener("goToSlide", (e) => {
          const slideIndex = e.detail;
          prodsSplide.go(parseFloat(slideIndex));
        });
      }
    });
  }
}

customElements.define("ugc-modal", UGCModal);

class UGCGalleryToggle extends HTMLElement {
  constructor() {
    super();

    if (!this.hasAttribute("data-disable-modal")) {
      this.gallery = this.closest(".shopify-section").querySelector("ugc-modal");
      if (this.gallery) {
        this.addEventListener("click", () => {
          this.gallery.openGallery();
  
          if (this.getAttribute("data-slide")) {
            this.gallery.main_slider.dispatchEvent(
              new CustomEvent("goToSlide", {
                detail: this.getAttribute("data-slide"),
              })
            );
          }
        });
      }
    }
  }
}

customElements.define("ugc-gallery-toggle", UGCGalleryToggle);

class UGCGallerySlider extends HTMLElement {
  constructor() {
    super();
    this.modal = this.closest("ugc-modal");
    this.slider = this.querySelector(".ugc-gallery-slider");
    if (this.slider) {
      this.initSlider();
      this.volumeControls();
      this.playbackControls();
      this.videoLoop();

      this.slider.addEventListener("goToSlide", (e) => {
        const slideIndex = e.detail;
        this.ugcSplide.go(parseFloat(slideIndex));
      });

      if (this.modal && this.modal.open_on_load) {
        const ugcSlide = sessionStorage.getItem("ugc_gallery_slide");
        if (ugcSlide) {
          this.slider.dispatchEvent(
            new CustomEvent("goToSlide", {
              detail: ugcSlide,
            })
          );
        }

        const ugcProd = sessionStorage.getItem("ugc_gallery_prod");
        if (ugcProd) {
          const mainSlide = this.querySelector(
            ".ugc-gallery-slider__slide.is-active"
          );
          if (!mainSlide) return;
          const productSlider = mainSlide.querySelector(".ugc-products-slider");
          if (productSlider) {
            productSlider.dispatchEvent(
              new CustomEvent("goToSlide", {
                detail: sessionStorage.getItem("ugc_gallery_prod"),
              })
            );
          }
        }
      }
    }
  }

  connectedCallback() {
    this.querySelectorAll("a").forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
      });
    });
  }

  initSlider() {
    let ugcGalleryOptions = {
      arrows: false,
      type: "slide",
      perPage: 1,
      drag: "free",
      snap: true,
      direction: "ttb",
      paginationDirection: "ttb",
      heightRatio: 1,
      updateOnMove: true,
      classes: {
        pagination: "splide__pagination product-gallery-pagination",
        page: "splide__pagination__page product-gallery-page",
      },
    };

    if (this.closest(".product-gallery")) {
      ugcGalleryOptions = {
        ...ugcGalleryOptions,
        direction: "ltr",
        paginationDirection: "ltr",
      };
    }

    this.ugcSplide = new Splide(this.slider, ugcGalleryOptions).mount();

    this.ugcSplide.on("active", () => {
      this.ugcSplide.root.dispatchEvent(new Event("moved"));
    });

    this.slider.addEventListener("moved", (e) => {
      const bounceAnimated = this.querySelector(
        ".ugc-gallery-slider__slide.bounce"
      );
      if (bounceAnimated) {
        bounceAnimated.classList.remove("bounce");
        this.classList.remove("has-overlay");
      }
    });
  }

  volumeControls() {
    const volumeElements = this.querySelectorAll(".volume");
    volumeElements.forEach((el) => {
      el.addEventListener("click", () => {
        el.classList.toggle("volume-on");
        el.classList.toggle("volume-off");

        let video = el.closest(".ugc-media").querySelector("video");
        if (!video) {
          video = el.closest(".ugc-media").querySelector("iframe");
        }

        if (!video) return;

        if (video.classList.contains("js-vimeo")) {
          const player = new Vimeo.Player(video);

          player.getVolume().then(function (volume) {
            if (volume > 0 && volume < 1) {
              player.setVolume(0);
            } else {
              player.setVolume(0.8);
            }
          });
        } else {
          video.muted = !video.muted;
          video.play();
        }
      });
    });
  }

  playbackControls() {
    const playbackElements = this.querySelectorAll(".playback");
    playbackElements.forEach((el) => {
      el.addEventListener("click", () => {
        el.classList.toggle("playback-play");
        el.classList.toggle("playback-pause");

        let video = el.closest(".ugc-media").querySelector("video");
        if (!video) {
          video = el.closest(".ugc-media").querySelector("iframe");
        }

        if (!video) return;

        if (video.classList.contains("js-vimeo")) {
          const player = new Vimeo.Player(video);

          player.getPaused().then(function (paused) {
            if (paused) {
              player.play();
            } else {
              player.pause();
            }
          });
        } else {
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        }
      });
    });
  }

  videoLoop() {
    const video = this.querySelector("video");
    if (video && !this.closest(".product-gallery")) {
      video.loop = false;
      // Listen for the first 'ended' event
      video.addEventListener("ended", () => {
        // Add your class
        video.classList.add("played-once");
        video.closest(".ugc-gallery-slider__slide").classList.add("bounce");
        this.classList.add("has-overlay");
        // Re-enable looping
        video.loop = true;
        video.play(); // Start looping playback
      });
    }
  }
}

customElements.define("ugc-gallery-slider", UGCGallerySlider);
